const zhHK = {
  // 导航
  nav_intro: '公司簡介',
  nav_business: '業務範圍',
  nav_events: '行業活動',
  nav_team: '核心團隊',
  nav_achievements: '業績成就',
  nav_contact: '聯繫我們',
  
  // 首页英雄区
  hero_main_title: '專業蘋果手機',
  hero_main_subtitle: '全球貿易專家',
  hero_company_intro: '香港博鑫貿易有限公司（Hong Kong BOJM Trading Co., Ltd.）成立於',
  hero_company_year: '2011年',
  hero_company_desc: '，是一家專注於蘋果手機全球貿易的專業公司。',
  hero_business_desc: '我們專業從事',
  hero_product_1: '蘋果資源機',
  hero_product_2: '蘋果新機',
  hero_product_3: '蘋果二手機',
  hero_business_coverage: '的銷售業務，業務覆蓋歐洲、迪拜、拉美、東南亞等全球市場。',
  hero_cta_contact: '聯繫我們',
  hero_cta_learn: '了解更多',
  
  // 公司简介
  intro_title: '關於',
  intro_title_highlight: '博鑫貿易',
  intro_company_name: '香港博鑫貿易有限公司',
  intro_company_name_en: 'Hong Kong BOJM Trading Co., Ltd.',
  intro_founded: '成立於',
  intro_founded_year: '2011年',
  intro_desc_1: '，是一家專注於蘋果手機全球貿易的專業公司。經過十餘年的發展，我們已成為行業內備受信賴的合作夥伴。',
  intro_desc_2: '公司專業從事',
  intro_desc_3: '的銷售業務，憑藉豐富的行業經驗和廣泛的供應鏈網絡，為全球客戶提供優質的產品和服務。',
  intro_stat_year: '2011',
  intro_stat_year_label: '公司成立年份',
  intro_stat_coverage: '4+',
  intro_stat_coverage_label: '覆蓋全球區域',
  intro_experience: '13+',
  intro_experience_label: '年行業經驗',
  
  // 业务范围
  business_title: '我們的',
  business_title_highlight: '業務',
  business_subtitle: '專注於蘋果手機全球貿易，為客戶提供',
  business_subtitle_bold_1: '蘋果新機',
  business_subtitle_bold_2: '蘋果資源機',
  business_subtitle_bold_3: '蘋果二手機',
  business_subtitle_end: '的專業銷售服務',
  
  business_new_title: '蘋果新機',
  business_new_desc: '提供最新款iPhone系列產品，全新未拆封，原裝正品保證，支持全球聯保服務。',
  business_new_feature_1: '全新未拆封',
  business_new_feature_2: '原裝正品',
  business_new_feature_3: '全球聯保',
  
  business_resource_title: '蘋果資源機',
  business_resource_desc: '優質資源機貨源，經過嚴格質檢，性價比高，適合批量採購和渠道分銷。',
  business_resource_feature_1: '嚴格質檢',
  business_resource_feature_2: '批量優惠',
  business_resource_feature_3: '渠道優勢',
  
  business_used_title: '蘋果二手機',
  business_used_desc: '精選優質二手iPhone，經過專業檢測和翻新，品質可靠，價格實惠，性價比之選。',
  business_used_feature_1: '專業檢測',
  business_used_feature_2: '品質保證',
  business_used_feature_3: '價格實惠',
  
  business_coverage_title: '全球業務覆蓋',
  business_coverage_subtitle: '我們的產品和服務遍布全球四大核心市場',
  business_region_europe: '歐洲',
  business_region_europe_en: 'Europe',
  business_region_dubai: '迪拜',
  business_region_dubai_en: 'Dubai',
  business_region_latam: '拉美',
  business_region_latam_en: 'Latin America',
  business_region_sea: '東南亞',
  business_region_sea_en: 'Southeast Asia',
  
  // 行业活动
  events_title: '行業',
  events_title_highlight: '活動',
  events_subtitle: '積極參與',
  events_subtitle_bold: '香港國際通信電子商會',
  events_subtitle_end: '等行業組織活動，與全球合作夥伴保持緊密聯繫',
  
  events_event1_title: '香港國際通信電子商會年度峰會',
  events_event1_date: '2025年11月13日',
  events_event1_desc: '首屆就職典禮暨晚宴隆重舉行，超過200間會員企業共襄盛舉。香港 - 由業界領袖共同發起的香港國際通信電子商貿會（HKICEC）於2025年11月13日宣告正式成立，並假座香港會議展覽中心（新翼）舉行首屆就職典禮暨晚宴，標誌着香港通訊電子商貿產業邁向新里程。活動匯聚了超過200間會員企業，以及全球百大、來自本地、內地及海外的業界代表、政策制定者和商界翹楚出席，高朋滿座，場面盛大，氣氛熱烈。',
  
  events_event2_title: '香港國際通信電子商會交流活動',
  events_event2_date: '2025年11月13日',
  events_event2_desc: '商會成員企業代表齊聚一堂，共同探討行業發展趨勢與合作機遇。活動現場氣氛熱烈，各企業代表就通信電子商貿領域的最新動態、市場機遇以及未來發展方向進行了深入交流，為推動香港通信電子商貿產業的創新發展貢獻智慧與力量。',
  
  events_tag_1: '香港國際通信電子商會',
  events_tag_2: '行業峰會',
  events_tag_3: '國際交流',
  events_member_badge: '會員單位',
  
  // 核心团队
  team_title: '我們的',
  team_title_highlight: '核心團隊',
  team_subtitle: '經驗豐富的管理團隊，引領公司持續發展和創新',
  
  team_ceo_name: '張國松',
  team_ceo_position: 'CEO / 首席執行官',
  team_ceo_desc: '擁有20多年手機行業從業經歷,曾與傳音、小米等知名品牌深度合作,在手機貿易領域擁有豐富的經驗和廣泛的行業資源。',
  
  team_sales_name: '李承瑞',
  team_sales_position: '銷售與運營主管',
  team_sales_desc: '負責公司銷售策略制定和運營管理,帶領團隊開拓全球市場,確保業務高效運轉和持續增長。',
  
  // 业绩成就
  achievements_title: '我們的',
  achievements_title_highlight: '業績成就',
  achievements_subtitle: '持續增長的業績表現，見證我們的專業實力和市場信賴',
  
  achievements_last_year: '20億',
  achievements_last_year_label: '去年銷售額',
  achievements_last_year_period: '2023年度銷售業績',
  
  achievements_this_year: '50億',
  achievements_this_year_label: '今年銷售額',
  achievements_this_year_period: '2024年度銷售業績',
  
  achievements_growth_title: '年度增長率',
  achievements_growth_desc_1: '從2023年的20億到2024年的50億，我們實現了',
  achievements_growth_rate: '150%',
  achievements_growth_desc_2: '的驚人增長，這充分證明了我們的市場競爭力和客戶信賴度。',
  achievements_year_2023: '2023年',
  achievements_year_2024: '2024年',
  achievements_growth_indicator: '+150%',
  
  achievements_stat_experience: '13+',
  achievements_stat_experience_label: '年行業經驗',
  achievements_stat_markets: '4+',
  achievements_stat_markets_label: '全球市場區域',
  achievements_stat_team: '專業',
  achievements_stat_team_label: '核心管理團隊',
  achievements_stat_quality: '優質',
  achievements_stat_quality_label: '產品與服務',
  
  // 联系我们
  contact_title: '聯繫',
  contact_title_highlight: '我們',
  contact_intro: '歡迎與我們取得聯繫，我們將為您提供專業的諮詢服務和優質的產品解決方案。',
  
  contact_address_title: '公司地址',
  contact_address_value: '香港觀塘區鴻圖道1號2021室',
  contact_address_value_en: 'Room 2021, No.1 Hung To Road, Kwun Tong, Hong Kong',
  
  contact_phone_title: '聯繫電話',
  contact_phone_value: '+852 6468 5009',
  
  contact_email_title: '聯繫郵箱',
  contact_email_value: 'dragonlee03@163.com',
  
  contact_coverage_title: '業務覆蓋',
  contact_coverage_value: '歐洲 · 迪拜 · 拉美 · 東南亞',
  
  contact_hours_title: '工作時間',
  contact_hours_value: '週一至週五 9:00 - 18:00',
  
  contact_form_name: '姓名',
  contact_form_name_placeholder: '請輸入您的姓名',
  contact_form_email: '郵箱',
  contact_form_email_placeholder: '請輸入您的郵箱',
  contact_form_phone: '電話',
  contact_form_phone_placeholder: '請輸入您的聯繫電話',
  contact_form_company: '公司名稱',
  contact_form_company_placeholder: '請輸入您的公司名稱',
  contact_form_message: '留言',
  contact_form_message_placeholder: '請輸入您的留言內容',
  contact_form_submit: '提交留言',
  contact_form_submitting: '提交中...',
  contact_form_success: '提交成功！我們會盡快與您聯繫。',
  contact_form_error: '提交失敗，請稍後重試。',
  contact_form_char_limit: '/500',
  
  // 页脚
  footer_company_name: '香港博鑫貿易有限公司',
  footer_company_name_en: 'Hong Kong BOJM Trading Co., Ltd.',
  footer_company_desc: '專注於蘋果手機全球貿易，為客戶提供優質的產品和專業的服務。',
  
  footer_quick_links: '快速鏈接',
  footer_link_about: '關於我們',
  footer_link_business: '業務範圍',
  footer_link_team: '核心團隊',
  footer_link_achievements: '業績成就',
  footer_link_contact: '聯繫我們',
  
  footer_products_title: '業務產品',
  footer_product_new: '蘋果新機',
  footer_product_resource: '蘋果資源機',
  footer_product_used: '蘋果二手機',
  
  footer_regions_title: '覆蓋區域',
  footer_region_europe: '歐洲',
  footer_region_dubai: '迪拜',
  footer_region_latam: '拉美',
  footer_region_sea: '東南亞',
  
  footer_copyright: '© 2024 香港博鑫貿易有限公司 Hong Kong BOJM Trading Co., Ltd. 版權所有',
  footer_powered: 'Powered by Readdy',
};

export default zhHK;
